module.exports = ".red {\n  color: red;\n  font-weight: bold; }\n"